import script from "./UploadImage.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadImage.vue?vue&type=script&setup=true&lang=js"

import "./UploadImage.vue?vue&type=style&index=0&id=af0c77d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af0c77d6"]])

export default __exports__